import apiClient from "../apiClient";

const endpoint = "/api/players/";

export const getPlayers = async () => {
  const response = await apiClient.get(endpoint);
  return response.data;
};

export const createPlayer = async (data) => {
  const response = await apiClient.post(endpoint, data);
  return response.data;
};

export const updatePlayer = async (id, data) => {
  const response = await apiClient.put(`${endpoint}/${id}`, data);
  return response.data;
};

export const deletePlayer = async (id) => {
  const response = await apiClient.delete(`${endpoint}/${id}`);
  return response.data;
};